import {RequestInfo} from "@khan/shared-core";

import {E2EMailbox} from "./e2e-mailbox.ts";
import {ExtensionMailbox} from "./extension-mailbox.ts";
import {MobileAppMailbox} from "./mobile-app-mailbox.ts";
import type {Mailbox} from "./types.ts";

/**
 * We cache the mailbox as the mode isn't going to change.
 */
let mailbox: Mailbox | void;

/**
 * Get the mailbox for sending messages in the current environment.
 */
export const getMailbox = (): Mailbox | void => {
    if (!mailbox) {
        if (RequestInfo.isE2E) {
            // When we are E2E testing, we use a special mailbox.
            mailbox = new E2EMailbox();
        } else if (RequestInfo.isMobileApp) {
            mailbox = new MobileAppMailbox();
        } else if (RequestInfo.isExtension) {
            mailbox = new ExtensionMailbox();
        }
    }
    return mailbox;
};

/**
 * Remove the existing mailbox so that subsequent access creates a new one.
 *
 * This is useful for testing since `jest.isolateModules` isn't helping.
 */
export const resetMailbox = (): void => {
    mailbox = undefined;
};
